import React from "react";
import { Link } from "react-router-dom";
import AppShell from "@/components/AppShell";
import { MissionEyebrow } from "@/components/Mission";

const TILES = [
  {
    to: "/app/saver",
    eyebrow: "Money Saver Guide",
    title: "Find every dollar you can save",
    body: "An AI playbook ranked by dollar impact — fee waivers, merit aid plays, appeal scripts. Specific to your situation.",
    cta: "Build my playbook",
    testid: "tile-saver",
  },
  {
    to: "/app/dream-school",
    eyebrow: "Dream School Rescue",
    title: "Get to the school you think you can't afford",
    body: "Type the school. We return your real path — net price, scholarships, appeal angle, transfer route — quantified in dollars.",
    cta: "Run a rescue plan",
    testid: "tile-dream",
  },
  {
    to: "/app/calendar",
    eyebrow: "Financial Aid Calendar",
    title: "Every deadline that matters",
    body: "ED, EA, FAFSA, CSS, aid priority, deposit, renewal — generated from your college list, color-coded by urgency.",
    cta: "Generate my calendar",
    testid: "tile-calendar",
  },
  {
    to: "/app/fafsa",
    eyebrow: "FAFSA Walkthrough",
    title: "Filed without panic",
    body: "An adaptive teacher walks every section in plain English with worked examples and the 3 mistakes most filers make.",
    cta: "Walk me through FAFSA",
    testid: "tile-fafsa",
  },
];

export default function DashboardPage() {
  return (
    <AppShell>
      <div className="py-10" data-testid="dashboard-root">
        <MissionEyebrow testId="dashboard-mission" />
        <h1 className="font-heading italic text-4xl sm:text-5xl text-[#0f172a] mb-3 leading-tight">
          Your AidWaive plan, all in one place.
        </h1>
        <p className="text-slate-600 mb-10 max-w-2xl">
          Four free agents, no sign-up required. Your basics save in your browser
          (localStorage) so each tool can pick up where you left off — clear them anytime.
        </p>

        <div className="grid sm:grid-cols-2 gap-4">
          {TILES.map((t) => (
            <Link key={t.to} to={t.to} data-testid={t.testid}
              className="group aw-card bg-white border border-[#bfdbfe] hover:border-[#1d4ed8] rounded-2xl p-6 sm:p-8 transition flex flex-col">
              <div className="text-xs uppercase tracking-widest text-[#1d4ed8] mb-3">{t.eyebrow}</div>
              <h2 className="font-heading italic text-2xl sm:text-3xl text-[#0f172a] mb-3">{t.title}</h2>
              <p className="text-sm text-slate-600 leading-relaxed mb-6 flex-1">{t.body}</p>
              <span className="inline-flex items-center text-sm text-[#1d4ed8] font-medium">
                {t.cta} <span className="ml-1 group-hover:translate-x-0.5 transition-transform">→</span>
              </span>
            </Link>
          ))}
        </div>

        <div className="mt-12 grid sm:grid-cols-3 gap-3">
          {[
            ["Net Price Calculator", "/netprice"],
            ["Decode Award Letter", "/decoder"],
            ["Find Schools", "/find"],
            ["Compare Aid Offers", "/compare"],
            ["Scholarships", "/scholarships"],
            ["Appeal Letter", "/appeal"],
          ].map(([label, to]) => (
            <Link key={to} to={to} data-testid={`dashboard-tool-${to.slice(1)}`}
              className="rounded-xl bg-white border border-[#bfdbfe] hover:border-[#1d4ed8] px-5 py-4 text-sm text-[#0f172a] transition">
              {label}<span className="text-slate-400 ml-2">→</span>
            </Link>
          ))}
        </div>
      </div>
    </AppShell>
  );
}
